export const CHATBOT_NODE_TYPE = [
    {name: 'Greeting', value: 'greeting', visible:false},
    {name: 'Message', value: 'message', visible:true},
    {name: 'Question', value: 'question', visible:true},
    {name: 'Capture Visitor', value: 'capture-visitor', visible:true},
    {name: 'Capture Property', value: 'capture-property', visible:true},
    {name: 'User Details', value: 'capture-user-details', visible:true},
    {name: 'Location', value: 'capture-location', visible:true},
    {name: 'Live Chat', value: 'live-chat', visible:true},
    {name: 'Lead - Valuation', value: 'schedule-valuation', visible:true},
    {name: 'Lead - Viewing', value: 'property-viewing', visible:true},
    {name: 'Lead - Callback', value: 'arrange-callback', visible:true},
    {name: 'Option', value: 'option', visible:false},
    {name: 'Close chat', value: 'closing', visible:true},
];